import { Answer } from '../models/answer.model';
import { Question } from '../models/question.model';
import { MultiQuestions } from '../models/multi-questions';

export interface StandardQuestionDraft {
  questionTextRu: string;
  questionTextEn: string;
  rightAnswerRu: string | number;
  rightAnswerEn: string | number;
  checked?: boolean;
  answers: {
    answerOneRu: string; answerTwoRu: string; answerThreeRu: string;
    answerOneEn: string; answerTwoEn: string; answerThreeEn: string;
  }[];
}

const RUSSIAN_SUFFIX = 'Ru';
const ENGLISH_SUFFIX = 'En';
const ANSWER_NUMBER_OFFSET = 1;
const FIRST_ANSWER_GROUP = 0;
const QUESTION_FIELDS = { first: 'answerOne', second: 'answerTwo', third: 'answerThree', right: 'rightAnswer', text: 'questionText' };

export function standardQuestionsFromDraft(draft: StandardQuestionDraft[]): MultiQuestions {
  return new MultiQuestions(
    draft.map(question => questionFromDraft(question, RUSSIAN_SUFFIX)),
    draft.map(question => questionFromDraft(question, ENGLISH_SUFFIX))
  );
}

function questionFromDraft(draft: StandardQuestionDraft, language: string): Question {
  const source = draft.answers[FIRST_ANSWER_GROUP];
  const answers = [source[QUESTION_FIELDS.first + language], source[QUESTION_FIELDS.second + language], source[QUESTION_FIELDS.third + language]]
    .map(text => new Answer(text));
  const rightAnswer = answers[Number(draft[QUESTION_FIELDS.right + language]) - ANSWER_NUMBER_OFFSET];
  return new Question(answers, draft.checked, draft[QUESTION_FIELDS.text + language], rightAnswer);
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/standard-question-draft.ts